module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDEwIDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcgMGgzdjE0SDdWMHpNMCAwaDN2MTRIMFYweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/assets/play/pause-icon.svg
// module id = 1685
// module chunks = 1 2 3